/**
 * Stamps every backend call with the operator's mobile + login session id so the
 * Performance Console can attribute traffic to a user and force-log-out a device.
 * One-time patch of window.fetch + axios defaults.
 */
import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
let currentMobile = '';
let currentSession = '';
let patched = false;

export const getSessionId = () => localStorage.getItem('erp_session_id') || '';

export const setRequestIdentity = (user) => {
  currentMobile = user?.c_mobile || user?.mobile || user?.c_user_mobile || '';
  currentSession = getSessionId();
  if (currentMobile) axios.defaults.headers.common['X-User-Mobile'] = currentMobile;
  else delete axios.defaults.headers.common['X-User-Mobile'];
  if (currentSession) axios.defaults.headers.common['X-Session-Id'] = currentSession;
  else delete axios.defaults.headers.common['X-Session-Id'];

  if (patched) return;
  patched = true;
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    if ((currentMobile || currentSession) && BACKEND && url.startsWith(BACKEND)) {
      const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined) || {});
      if (currentMobile && !headers.has('X-User-Mobile')) headers.set('X-User-Mobile', currentMobile);
      if (currentSession && !headers.has('X-Session-Id')) headers.set('X-Session-Id', currentSession);
      return nativeFetch(input, { ...init, headers });
    }
    return nativeFetch(input, init);
  };
};
